var _excluded = ["level", "tag", "tagName", "text", "children", "className", "size"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import cs from 'classnames';
/**
 * Status: *finished*.
 * Category: Style
 *
 * The Heading component should be used for page titles, sub-titles, etc.
 * Currently, only h1, h2, h3 and h4 headings have been defined.
 *
 * Margin for headings should be handled in the components that make use of this component.
 * See <a href='/information-article-5' class='link'>this sample page</a> that make use of the
 * <a href='/components/molecules#RichText' class='link'>RichText component</a> to style headings in running text.
 *
 * Heading can be centered by applying heading--centered.
 */

var defaultSizeByTag = {
  h1: 'xxl',
  h2: 'xl',
  h3: 'l',
  h4: 'm',
  h5: 's',
  h6: 'xs'
};

var Heading = function Heading(props) {
  var level = props.level,
      tag = props.tag,
      tagName = props.tagName,
      text = props.text,
      children = props.children,
      className = props.className,
      size = props.size,
      rest = _objectWithoutProperties(props, _excluded);

  var Tag = tag || 'h1'; // Check deprecated values for level and tagName

  if (props.level) {
    Tag = "h".concat(props.level);
  }

  if (props.tagName) {
    Tag = props.tagName;
  }

  var hSize = size || defaultSizeByTag[Tag] || 'xxl';
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: cs('heading', props.className, hSize ? "heading--".concat(hSize) : undefined, props.level ? "heading--level-".concat(props.level) : undefined),
    style: props.style
  }, rest), text, children);
};

export default Heading;